import { Component, OnInit, ViewChild, ElementRef, NgZone, Renderer, OnDestroy } from '@angular/core';
import { BuildingsService } from "../../../service/buildings.service";
import { ActivatedRoute, Router, RouteReuseStrategy } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { Store } from '@ngrx/store';
import { AppState } from '../../../models/app.state';
import { MapsAPILoader } from '@agm/core';
import { HttpService } from '../../../service/http.service';
import { FeedService } from '../../../service/feed.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ADD_BUILDING, IMAGE_RESET, JOIN_BUILDING } from 'src/app/reducers/building.reducers';
import { BUILDING_RESET } from 'src/app/actions/building.actions';

declare var $: any;

@Component({
  selector: 'app-buildings',
  templateUrl: './buildings.component.html',
  styleUrls: ['./buildings.component.css']
})
export class BuildingsComponent implements OnInit, OnDestroy {

  //Buildings Variables
  totalBuildings = 0;
  myBuildings = [];
  allBuildings = [];
  buildingList = [];

  // Get current loggedIn user ID
  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  userBuildingId = localStorage.getItem('userBuildingId');
  userType = localStorage.getItem('type');

  apiUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;

  error;
  conflictAddress;
  address: any = {};
  isManagerStatus;
  isaddanotherbuilding: boolean;

  addressComponent;
  removableData;
  add;
  existingBuildingImage;
  url;
  newBuilding;
  newBuildingAdded = false;

  addressSearchModal;
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;

  @ViewChild('submit',  { static: false })
  public submit: ElementRef;

  constructor(private buildingService: BuildingsService,
    private router: Router,
    private store: Store<AppState>,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private renderer: Renderer,
    private _http: HttpClient,
    private httpService: HttpService,
    private route: ActivatedRoute,
    private _feed: FeedService,) { }

  ngOnInit() {
    localStorage.removeItem('buildingImage');
    sessionStorage.removeItem('existingBuildingImage');
    sessionStorage.removeItem('buildingImage');
    localStorage.removeItem('tempBuildDetails');
    this.route.queryParams.subscribe(
      (params) => {
        console.log('params', params);
        this.newBuildingAdded = params.done;
      }
    );

    setTimeout(
      () => {
        this.newBuildingAdded = false;
      }, 3000
    );

    if (this.isManager === 'true' && this.userType !== 'admin') {
      this.buildingService.getAllBuildingsByUserId(this.id).subscribe(
        (buildings) => {
          console.log(buildings.data[0].building);
          if (buildings.success) {
            this.myBuildings = buildings.data[0].building;
            this.buildingList = buildings.data[0].building;
            this.totalBuildings = buildings.data[0].building.length;
            console.log('My Buildings: ', this.myBuildings);
            if (this.myBuildings.length <= 1) {
              this.allBuildings.push(this.myBuildings[0].id);
            } else {
              for (let building of this.myBuildings) {
                this.allBuildings.push(building.id);
              }
            }
            this.totalBuildings = this.allBuildings.length;
          }
        }
      );
    } else if (this.userType === 'admin') {
      let buildingIds;
      this.buildingService.getAllBuildingsByUser(buildingIds).subscribe(
        (buildings) => {
          if (buildings.success) {
            this.myBuildings = buildings.data;
            this.buildingList = buildings.data;
            this.totalBuildings = buildings.data.length;
            console.log('My Buildings: ', this.myBuildings);
            if (this.myBuildings.length <= 1) {
              this.allBuildings.push(this.myBuildings[0].id);
            } else {
              for (let building of this.myBuildings) {
                this.allBuildings.push(building.id);
              }
            }
            this.totalBuildings = this.allBuildings.length;
          }
        });
    }
    else {
      this.router.navigate(['/feed']);
    }


    this.store.select('build').subscribe((data: any) => {
      console.log('Existing Building : ', data);
      this.addressComponent = '';
      this.addressComponent = data;

      this.add = data[0].address['adr_address'];
      let count = 0;
      if (this.add) {
        for (let i = 0; i < this.add.length; i++) {
          if (this.add.charAt(i) == '<') {
            console.log('if');
            break;
          } else {
            count++;
          }
        }
        console.log(count, 'hello');
        this.removableData = this.add.substring(0, count);
        console.log(this.removableData);
        this.add = this.add.replace(this.removableData, '');
        console.log(this.add);
        this.add = this.add.replace(/,/gi, '');
        this.add = this.add.replace(/<\/span> /gi, '</span>,');
        console.log(this.add);
        this.add = this.add.split(',');

        this.store.subscribe((data: any) => {
          //this.totalBuildings = data.buildDetails.length;
        }).unsubscribe();

        if (this.addressComponent[0].address.buildingImage) {
          this.existingBuildingImage = (this.addressComponent[0].address.buildingImage.split('assets').length > 1) ?
            this.addressComponent[0].address.buildingImage.split('assets')[1] :
            (this.addressComponent[0].address.buildingImage.split('building').length > 1) ?
              'building' + this.addressComponent[0].address.buildingImage.split('building')[1] :
              this.addressComponent[0].address.buildingImage.split('assets')[1];
          this.existingBuildingImage ? sessionStorage.setItem('existingBuildingImage', this.existingBuildingImage) : '';
          // this.showPreview(this.addressComponent[0].address.buildingImage[0].coords);
          //console.log(this.addressComponent[0].address.buildingImage);
          this.url = this.addressComponent[0].address.buildingImage.fd;
        }
        this.newBuilding = data[0].newBuilding;
      }
      //this.latitude = data[0].address.coords.lat;
      //this.longitude = data[0].address.coords.lng;
    });

    setTimeout(() => {
      this._feed.getAllFeeds();
    }, 1000);



    //======================map section============

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: []
      });
      autocomplete.addListener('place_changed', (status) => {
        this.store.dispatch({ type: IMAGE_RESET});
        localStorage.removeItem('buildingImage');
        sessionStorage.removeItem('existingBuildingImage');
        sessionStorage.removeItem('buildingImage');
        localStorage.removeItem('tempBuildDetails');
        this.error = null;
        console.log(status);
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result

          console.log(this.conflictAddress);
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.conflictAddress = place.formatted_address;
          // set latitude, longitude and zoom


          this.renderer.listen(this.submit.nativeElement, 'click', (event) => {

            //this.latitude = place.geometry.location.lat();
            //this.longitude = place.geometry.location.lng();
            //this.zoom = 17;
            this.address.adr_address = place['adr_address'];
            this.address.formattedAddress = place.formatted_address;
            this.address.coords = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng()
            };
            this.address.placeId = place.place_id;
            //this.address.buildingName = this.buildingName;
            console.log(this.address.placeId);
            if ($.trim(this.conflictAddress) == '') {
              this.error = 'Please enter your address';
            } else if (place.formatted_address != this.conflictAddress) {
              this.error = 'Address is invalid';
              console.log(place.formatted_address != this.conflictAddress);
            } else {
              this.error = null;



              const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${this.address.formattedAddress}&key=${environment.googleMapsApiKey}`;

              this._http.get(url).pipe(
                map((res: any) => res.results[0].geometry.location)
              ).subscribe(data => {
                let tempCoords = data;
                let temp = { ...tempCoords };
                let value1 = temp.lat;
                let value2 = temp.lng;
                let val1 = value1.toString();
                let val2 = value2.toString();
                let length1 = (val1.split('.')[1] || '').length;
let length2 = (val2.split('.')[1] || '').length;

                if (length1 > 7) {
                  tempCoords.lat = parseFloat(tempCoords.lat.toFixed(7))
                }

                if (length2 > 7) {
                  tempCoords.lng = parseFloat(tempCoords.lng.toFixed(7))
                }

                // const header = new Headers();
                // header.append('Content-Type', 'application/json');
                this._http.post(`${environment.apiUrl}mycoopbuildings/findmyCoopBuilding`, { address: tempCoords }).pipe(
                  map(response => response) // Adjust the response type if needed
                )
                .subscribe(data => {


                  console.log("Building Info ==================", data);

                  if (this.address.placeId) {
                    console.log(this.address.placeId);
                    this.httpService.isManager(tempCoords).subscribe(
                      (res) => {
                        console.log('step1');
                        this.isManagerStatus = false;
                      },
                      (error) => {
                        this.isManagerStatus = true;
                        console.log('restricted');

                      }
                    )
                  }

                  if (this.isManagerStatus == false) {
                    console.log('step2');
                    this.store.dispatch({ type: JOIN_BUILDING, payload: <any>{ address: data } });
                    localStorage.setItem('tempBuild', JSON.stringify(data));
                    $('#addbuildingmodal').modal('hide');
                    //this.router.navigate(['building'], {queryParams: {manager: 'true'}});
                    this.joinExistingBuilding();
                  } else {
                    console.log('success');
                    if (this.totalBuildings > 0 && this.isManagerStatus == true) {
                      this.error = "This building is already have building Manager. Hence you are not able to claim as building Manager";
                      $('#buildingWarning').modal('show');
                    } else {
                      this.store.dispatch({ type: JOIN_BUILDING, payload: <any>{ address: data } });
                      localStorage.setItem('tempBuild', JSON.stringify(data));
                      $('#addbuildingmodal').modal('hide');
                      //this.router.navigate(['building'],  {queryParams: {manager: 'true'}});
                      this.joinExistingBuilding();
                    }

                  }


                },
                  (error) => {
                    this.store.dispatch({ type: ADD_BUILDING, payload: <any>{ address: this.address } });
                    localStorage.setItem('tempBuild', JSON.stringify(this.address));
                    $('#addbuildingmodal').modal('hide');
                    this.router.navigate(['managerprofile', 'managerbuilding'], { queryParams: { add: 'new' } })
                  });

              });
            }
          });


        });
      });
    }).catch((error) => {
      console.log('-----------', error);
      this.error = error
      $('#myModal1').modal('show');

    });

    //=============================================
  }

  getImageUrl(blob): string {
    var imageUrl = URL.createObjectURL(blob);
    console.log('imageUrl', imageUrl);
    return imageUrl;
  }

  editBuilding(building) {
    this._http.get(`${environment.apiUrl}mycoopbuildings/getBuildingById/?buildingId=${building.id}`).pipe(
      map(response => response) // Adjust the response type if needed
    )
    .subscribe(data => {

      this.store.dispatch({ type: BUILDING_RESET, payload: [] });
      building.isManagerEdit = true;
      this.store.dispatch({ type: JOIN_BUILDING, payload: <any>{ address: data } });
      this.router.navigate(['/managerprofile/managerbuilding'], { queryParams: { edit: 'manager', buildingId: building.id } });
    });

  }

  AddressCheckpoint() {
    this.isaddanotherbuilding = false;
    //this.showFindBuilding = false;
    //this.buildingName = '';
    var searchAddress = this.conflictAddress;
    if (this.conflictAddress === undefined || $.trim(searchAddress) === '') {
      this.error = 'Please enter your address';
    } else if ($.trim(searchAddress) != '' && $.isEmptyObject(this.address)) {
      this.error = 'Address is invalid';
    } else {
      this.error = null;
    }
  }

  joinExistingBuilding() {
    $('#existingBuilding').modal('show');
  }

  JoinAsManager(build) {
    this.httpService.isManager(build.address.coords).subscribe(
      (res) => {
        $('#existingBuilding').modal('hide');
        this.store.dispatch({ type: JOIN_BUILDING, payload: <any>{ address: build.address } });
        this.router.navigate(['managerprofile', 'managerbuilding'], { queryParams: { add: 'new' } })
        console.log('restricted');
      },
      (error) => {

        console.log('step1');
        this.error = "This building already has the building manager";
        setTimeout(() => {
          $('#existingBuilding').modal('hide');
          this.error = null;
          this.conflictAddress = null;
        }, 2000);
        setTimeout(() => {
          $('#addbuildingmodal').modal('show');
        }, 3000)
      }
    )
  }

  addbuildingmodal() {
    this.store.dispatch({ type: BUILDING_RESET, payload: [] });
    $('#addbuildingmodal').modal('show');
  }

  ngOnDestroy() {
    this.store.subscribe().unsubscribe();
    $('#addbuildingmodal').modal('hide');
    $('#existingBuilding').modal('hide');
    $('#buildingWarning').modal('hide');
  }
}
